export function updateFaviconWithDot(originalFaviconPath: string) {
    const favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!favicon) return;
  
    const image = new Image();
    image.src = originalFaviconPath;
  
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 64;
      canvas.height = 64;
  
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
  
      ctx.drawImage(image, 0, 0, 64, 64);
  
      // Draw red dot (adjust position and size as needed)
      ctx.beginPath();
      ctx.arc(52, 12, 7, 0, 2 * Math.PI);
      ctx.fillStyle = '#FF0000';
      ctx.fill();
  
      favicon.href = canvas.toDataURL('image/png');
    };
  }
  
  export function resetFaviconToDefault(originalFaviconPath: string) {
    const favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (favicon) {
      favicon.href = originalFaviconPath;
    }
  }
  